import { Subject } from 'rxjs';

const subject = new Subject();

export const loaderService = {
    showSpinner: () => subject.next({showSpinner: true}),
    hideSpinner: () => subject.next({showSpinner: false}),
    showLoadingBackground: () => subject.next({showLoadingBackground: true}),
    hideLoadingBackground: () => subject.next({showLoadingBackground: false}),
    getLoadingSubj: () => subject,
}